import { Component } from '@angular/core';
import { NotificationLayout } from '../../../shared/layout/notification-layout/notification-layout';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-tecnical-failure',
  imports: [RouterLink, NotificationLayout],
  templateUrl: './tecnical-failure.html',
  styleUrl: './tecnical-failure.scss',
})
export class TecnicalFailure {}
